import { useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';

export type RecentStore = { id: number; name: string };

const RECENT_STORES_KEY = 'recent-stores';
const MAX_RECENT_STORES = 5;

export const useRecentStores = () => {
  const [recentStores] = useLocalStorage<RecentStore[]>(RECENT_STORES_KEY, []);
  return recentStores;
};

export const useTrackRecentStore = (store: RecentStore | undefined) => {
  const [, setRecentStores] = useLocalStorage<RecentStore[]>(
    RECENT_STORES_KEY,
    [],
  );

  // Depend on primitives (not the `store` object, which callers recreate each
  // render) and bail to the same reference when already at the front — both
  // are needed to avoid an infinite setState→render loop.
  const id = store?.id;
  const name = store?.name;
  useEffect(() => {
    if (id === undefined || name === undefined) return;
    setRecentStores((prev) => {
      if (prev[0]?.id === id && prev[0].name === name) return prev;
      return [{ id, name }, ...prev.filter((s) => s.id !== id)].slice(
        0,
        MAX_RECENT_STORES,
      );
    });
  }, [id, name, setRecentStores]);
};
